import type { SVGProps } from "react";
const SvgPlant04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    color="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 12v8M12 12v1h3a6 6 0 0 0 6-6V6h-3a6 6 0 0 0-6 6M12 10v1H9a6 6 0 0 1-6-6V4h3a6 6 0 0 1 6 6"
    />
  </svg>
);
export default SvgPlant04;
